/**
 * Inventory Store
 *
 * @since 2018-09-03
 * @author Nanhyoung.Ro <dev014>
 */
export const state = () => ({
  apiPreFix: '/api/lr',
  settingApi: '/monitor/setup/alerts',
  commandApi: '/command/setup-alerts',
  // ===  onSearch ===
  search: {
  },
  alertInfoList: [],
  defaultList: [],
  processList: [],
  chgProcessList: []
})

export const actions = {
  // 로그 설정 조회
  async getSearchResult ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}`
    try {
      result = await this.$axios.$get(apiUrl, {loading: false})
      if (result.code === 'ok') {
        state.defaultList = result.result
      } else {
        state.defaultList = []
      }

      state.alertInfoList = _.cloneDeep(state.defaultList)
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      state.defaultList = []
      state.alertInfoList = []
      return result
    }
  },
  async setAlertSettings ({commit, state}, updateList) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}`
    try {
      result = await this.$axios.$put(apiUrl, {items: updateList}, {loading: false, successAlert: false})
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  },

  // 경고 프로세스 설정 조회
  async getProcessResult ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}/processes`
    try {
      result = await this.$axios.$get(apiUrl)
      if (result.code === 'ok') {
        state.processList = result.result
      } else {
        state.processList = []
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      state.processList = []
      return result
    }
  },

  // 경고 프로세스 설정 수정
  async setProcessResult ({commit, state}, updateList) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}/processes`
    try {
      result = await this.$axios.$put(apiUrl, {items: updateList}, {loading: false})
      if (result.code === 'ok') {
        state.chgProcessList = updateList
      } else {
        state.chgProcessList = []
      }

      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  },

  async applySettings ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.commandApi}/apply`
    try {
      result = await this.$axios.$put(apiUrl, null, {loading: false, applyMsg: true})
      if (result.code === 'ok') {
        state.defaultList = _.cloneDeep(state.alertInfoList)
        state.chgProcessList = []
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  },

  async cancelSettings ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.commandApi}/cancel`
    try {
      result = await this.$axios.$put(apiUrl, null, {cancelMsg: true})
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  }
}

export const getters = {}
export const strict = false
